import base64url from "base64url";
import { intersection, map, split, parseInt, head } from "lodash";
import { AccountType } from "shared/constants/enums";
import { ACCOUNT_TYPES } from "shared/constants/appConstants";
import { PrivacyPolicyConfirmed } from "shared/store/models/privacyPolicyConfirmed";

export interface JwtContent {
    client_id: string;
    id: string;
    email: string;
    role: string;
    accountTypeIds: string;
    statusId: string;
    additionalDetails?: string;
    companyId: string;
    permissions: string;
    isPrivacyPolicyAndTermsAndConditionsConfirmed: PrivacyPolicyConfirmed;
    requiresMissingDetails: string;
}

export const parseJwt = (token: string): JwtContent => JSON.parse(base64url.decode(token.split(".")[1]));

export const getAccountTypeId = (roleIDsString: string): AccountType => {
    const roleIDs = map(split(roleIDsString, ","), parseInt);
    const roleID = intersection(roleIDs, ACCOUNT_TYPES);
    return head(roleID) as AccountType;
};
